import { Grid, Typography } from "@mui/material"
import excellarateLogo from '../../images/Excellarate-logo.svg';
import { useSelector } from "react-redux";
import { selectSurvey } from "./surveySlice";
import { useState } from "react";
import { SurveyQuestions } from "./SurveyQuestions";
import { SurveyMain } from "./SurveyMain";
import { useStyles } from "../Common/CommonStyle";
import { selectUserDetails } from "../UserDetails/userDetailsSlice";
import { SurveyEnd } from "./SurveyEnd";

export interface ISurvey {
  replay: () => void;
}
export const Survey = ({ replay }: ISurvey) => {
  const [startSurvey, setStartSurvey] = useState<boolean>(true);
  const [endSurvey, setEndSurvey] = useState<boolean>(false);
  const classes = useStyles();
  const [surveyData, setSurveyData] = useState([
    {
      questionId: 1,
      question: 'What do you think of the concept of metaverse?',
      options: [
        { option: 'It’s a gimmick', value: 'It’s a gimmick' },
        { option: 'It has some potential but not enough to create new channels and apps for it', value: 'It has some potential but not enough to create new channels and apps for it' },
        { option: 'I do not fully understand it', value: 'I do not fully understand it' }],
      disabled: false,
      name: 'question1',
    },
    {
      questionId: 2,
      question: 'Do you see any valid use cases for a metaverse-like environment in your business areas/industry?',
      options: [
        { option: 'Yes, certainly', value: 'Yes, certainly' },
        { option: 'Not really, no', value: 'Not really, no' },
        { option: 'Not sure', value: 'Not sure' }],
      disabled: true,
      name: 'question2',
    },
    {
      questionId: 3,
      question: 'Would a metaverse-like environment bring your customers closer to you or open a new demographic segment?',
      options: [
        { option: 'Yes, certainly', value: 'Yes, certainly' },
        { option: 'Not really, no', value: 'Not really, no' },
        { option: 'Not sure', value: 'Not sure' }],
      disabled: true,
      name: 'question3',
    },
    {
      questionId: 4,
      question: 'Would you want to do an exploratory study to understand if there are niche business areas the metaverse can open for you?',
      options: [
        { option: 'Yes, absolutely', value: 'Yes, absolutely' },
        { option: 'Not really, no', value: 'Not really, no' }],
      disabled: true,
      name: 'question4',
    }
  ]);

  const handleNext = (i: number) => {
    const changeQuestionOnNext = surveyData.map((item, index) => {
      if (i + 1 === index) {
        return {
          ...item,
          disabled: false
        }
      } else {
        return {
          ...item,
          disabled: true
        }
      }
    })
    setSurveyData(changeQuestionOnNext);
  }
  const { fname, lname, email } = useSelector(selectUserDetails);
  const { question } = useSelector(selectSurvey);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    fetch('https://go.excellarate.com/l/130341/2022-09-20/3rb4tk', {
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': '*/*' },
      mode: 'no-cors',
      referrer: "",
      body: new URLSearchParams({
        'fname': fname,
        'lname': lname,
        'email': email,
        'question1': question[0] ? question[0] : "",
        'question2': question[1] ? question[1] : "",
        'question3': question[2] ? question[2] : "",
        'question4': question[3] ? question[3] : ""
      })
    })
      .then(response => {
        setEndSurvey(true)
      })
      .catch((err) => {
        console.log("error -> ", err);
      });
  }

  return (
    <Grid container className={classes.positionComponent} sx={{ height: '100vh', background: 'rgba(12, 13, 33, 0.8)', backdropFilter: 'blur(12px)' }}>
      <Grid item xs={12}>
        <img src={excellarateLogo} alt="excellarate logo" style={{ padding: '1.25rem 0 0 1.875rem' }} />
      </Grid>
      {startSurvey ? (
        <SurveyMain setStartSurvey={setStartSurvey} />
      ) : (<>
        {endSurvey ? (
          <SurveyEnd replay={replay} />
        ) : (
          // eslint-disable-next-line array-callback-return
          surveyData?.map((item, index) => {
            if (!item?.disabled) {
              return <SurveyQuestions key={item.questionId} handleNext={handleNext} index={index} data={item} handleSubmit={handleSubmit} />
            }
          })
        )}
      </>)}
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'flex-end' }}>
        <Typography color='primary' style={{ padding: '0 0 1.25rem 1.875rem' }} >© 2022 Excellarate. All Rights Reserved</Typography>
      </Grid>
    </Grid>
  )
}


